









































import { Component, Vue, Watch } from 'vue-property-decorator';
import { EditPatchRequest, PatchViewObject } from '@/types/apiServerContract';
import { ApiPermissions } from '@/core/security/Permissions';
import { RealmApi } from '@/services/api/api.realms';
import { PatchApi } from '@/services/api/api.patches';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import bus from '@/core/bus';
import { BusConstants } from '@/core/constants';

@Component
export default class EditPatches extends Vue {
	permissions: string[] = [ApiPermissions.Realm.UploadPatch];

    patches: PatchViewObject[] = [];
    selectedPatch: PatchViewObject | null = null;

	request: EditPatchRequest = {
	    details: '',
	    keepUpdated: false,
	    patch: ''
	};

    @Watch('selectedPatch')
	onSelectedPatchChange(patch: PatchViewObject) {
	    this.request.details = patch?.details ?? '';
	    this.request.keepUpdated = patch?.keepUpdated ?? false;
	    this.request.patch = patch?.patch ?? '';
	}

	loading = false;

	async editPatch() {
	    if (!this.selectedPatch) return;

	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to edit this patch?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    try {
	        this.loading = true;
	        await RealmApi.UpdatePatch(this.request);

	        this.selectedPatch.details = this.request.details;
	        this.selectedPatch.keepUpdated = this.request.keepUpdated;
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Patch edited successfully', {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	Reset() {
	    this.request = {
	        details: '',
	        keepUpdated: false,
	        patch: ''
	    };
	}

	get activeRealmId() {
	    return RealmsModule.activeRealmId;
	}

	async getPatchFiles() {
	    this.Reset();

	    const result = await PatchApi.GetPatchData(this.activeRealmId);
	    this.patches = result.patches;
	}

	created() {
	    this.getPatchFiles();
	    bus.on(BusConstants.SelectedRealmChanged, this.getPatchFiles);
	}

	beforeDestroy() {
	    bus.off(BusConstants.SelectedRealmChanged, this.getPatchFiles);
	}
}
